// @flow
import * as React from 'react';
import styled from 'styled-components';
import Close from '../Icons/Close';

const ModalCloseStyled = styled.div`
	position: absolute;
	top: -1.5em;
	right: .5em;
`;

type Props = {
	onClick: Function
};

export const ModalClose = ({ onClick }: Props) => (
	<ModalCloseStyled onClick={onClick}>
		<Close cursor="pointer" color='#ffffff' />
	</ModalCloseStyled>
);

export default ModalClose;


// WEBPACK FOOTER //
// ./src/components/Modal/ModalClose.js